<template>
  <base-content-page :page-title="pageTitle" :caption="pageDescription">
    <v-container class="text-center">
      <v-card width="500px" class="mt-5 mx-auto">
        <p>
          Fill out the form below and a representitive from Epic Receptionists will get back to you with in 24 hours.
        </p>

        <v-divider />
        <contact-form class="mx-auto" />
      </v-card>
    </v-container>
  </base-content-page>
</template>
<script>
import BaseContentPage from '@/components/BaseContentPage'
import ContactForm from '@/components/ContactForm'

export default {
  components: {
    BaseContentPage,
    ContactForm
  },

  data: () => ({
    pageTitle: 'Contact Us',
    pageDescription: 'Want to get in touch? We would love to start a conversation. Here is how you can get ahold of us.'
  }),

  head() {
    return {
      title: this.pageTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageDescription
        }
      ]
    }
  }
}
</script>

<style scoped>
.number {
  font-size: 80px !important;
  width: 50px;
  /* margin-top: -24px; */
  color: lightgray;
}
</style>
